import { useHMSRoleChange } from "../hms";
import { useLivekitRoleChange } from "../livekit";
import type { ProviderRoleChange } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderRoleChange = (): ProviderRoleChange =>
  useProviderHook({
    hms: useHMSRoleChange,
    livekit: useLivekitRoleChange,
  })();
